export const WAREHOUSE_TASK_TYPE = 'WarehouseTaskType';
export const WarehouseTaskKindValues = [
    'putaway',
    'pick',
    'move',
    'count',
    'check',
];
export const WAREHOUSE_TASK_KIND_LABELS = {
    putaway: 'Armazenamento',
    pick: 'Picking',
    move: 'Movimentação',
    count: 'Contagem',
    check: 'Conferência',
};
export const WarehouseTaskExecutionModeValues = [
    'sequential',
    'list',
];
export const WAREHOUSE_TASK_EXECUTION_MODE_LABELS = {
    sequential: 'Um item por vez',
    list: 'Lista (edita as quantidades na lista)',
};
/** Verbs that may use list execution (0211 §1.1). */
export const WAREHOUSE_TASK_LIST_EXECUTION_KINDS = [
    'check',
    'count',
];
//# sourceMappingURL=warehouse-task-type.js.map